export enum PenaltyOutcome {
    PenaltyFor = 1,
    PenaltyAgainst = 2,
}